import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Nomatch from '../../components/Nomatch';
import {routingData} from '../../data';
import LowerNav from '../../features/lowerNav/LowerNav';
import PersonalHome from '../personal-home/PersonalHome';


const Personal = () => {
    document.title="R.B.S Personal Securities Options"

    return(
      <section>

        <LowerNav routingData={routingData[0]} />

        <Switch>
          <Route exact path="/h/personal">
              <PersonalHome />
          </Route>
          {
            routingData[0].map((path, index) => (
              <Route key={index} path={path.to} component={path.component} />
            ))
          }
          <Route component={Nomatch} />
        </Switch>
      </section>
    )
}

export default Personal;
